import {DayKey} from "../../../_shared/time/company-day";

export class ContractCreateModel {
  /** The first day, `yyyy-MM-dd`, exactly as picked (#802). */
  validFrom: DayKey = "";
  /** The last day, `yyyy-MM-dd`, included. The server stores it as it is; it does not add a day. */
  validTo: DayKey = "";
  shardCount: number = 0;
  deviceCount: number = 0;
  minimalMonthsPerDevice: number = 0;
  /**
   * Parallel **virtual events** licensed by this contract (#664). `-1` = unlimited, `0` = none.
   *
   * Last constructor parameter with a `0` default on purpose: every existing caller keeps compiling and keeps
   * sending the same thing it sent before the feature — "no virtual events" — rather than silently granting
   * some.
   */
  virtualEventCount: number = 0;

  constructor(validFrom: DayKey, validTo: DayKey, shardCount: number, deviceCount: number,
              minimalMonthsPerDevice: number, virtualEventCount: number = 0) {
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.shardCount = shardCount;
    this.deviceCount = deviceCount;
    this.minimalMonthsPerDevice = minimalMonthsPerDevice;
    this.virtualEventCount = virtualEventCount;
  }
}
